import { rootUrl } from "./global"

export const getJwtToken = (email, password) => rootUrl.post('/auth/login?version=v1', {email, password})

export const viewDashboard = () => rootUrl.get('/report/dashboard?version=v1')

export const deleteEmployee = (companyId) => rootUrl.delete(`/company/${companyId}?version=v1`)

export const updateEmployee = (employeeData) => rootUrl.post(`/employee?version=v1`, employeeData)

export const createEmployee = (employeeData) => rootUrl.post(`/employee?version=v1`, employeeData)

export const updateEmployeeOpen = (ref, employeeData) => 
  rootUrl.post(`employee/form/validate?version=v1&ref=${encodeURIComponent(ref)}`, employeeData);

export const showEmployee = (page = 1, size = 10, search = "") => {

  let url = `/employee?version=v1&page=${page - 1}&size=${size}`;
 
  if (search && search.trim() !== "") {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }
  
  return rootUrl.get(url);
};

export const validateFormLink = (refno) => rootUrl.get(`/employee/form/validate?ref=${refno}&version=v1`);

export const getEmployeeFormLink = (employeeId) => rootUrl.get(`/employee/formlink/${employeeId}?version=v1`);

export const getEmployeeById = (employeeId) => rootUrl.get(`/employee/${employeeId}?version=v1`);

export const uploadFile = (filedata) => rootUrl.post(`/cloud/upload?version=v1`, filedata)

export const uploadFileForm = (filedata, ref) => rootUrl.post(`/cloud/form/upload?version=v1&ref=${ref}`, filedata)


export const downloadFileForm = (fileName, ref) => {
    return rootUrl.get(`/cloud/form/download?version=v1&keyName=${fileName}&ref=${ref}`, {
        responseType: 'arraybuffer',
    });
};

export const downloadFile = (fileName) => {
    return rootUrl.get(`/cloud/download?version=v1&keyName=${fileName}`, {
        responseType: 'arraybuffer',
    });
};

export const exportReport = (reportType, startDate, endDate) =>
  rootUrl.get(
    `/report/export/${reportType}?version=v1&startDate=${startDate}&endDate=${endDate}`,
    { responseType: "arraybuffer" } // for Excel file download
  );


// Fetch all states
export const getStateList = () => rootUrl.get(`/list/state?version=v1`);

// Fetch all designations
export const getDesignationList = () => rootUrl.get(`/list/desig?version=v1`);

// Fetch all departments
export const getDepartmentList = () => rootUrl.get(`/list/department?version=v1`);
